export default __webpack_public_path__ + "static/media/kv_mettmann_signet.d55700dc.png";